
import { useEventReport } from "../redux/ReduxContext";

export interface TestIDData {
    testId: string;
    comment: string;
}
export default function TestID() {
    const { state, dispatch } = useEventReport();
    const { comment, testName } = state;
    return (
        <div className="bg-white dark:bg-oi-dark-background  p-4 flex flex-col mb-4 drop-shadow-md">
            <div className="flex flex-col lg:flex-row items-stretch mt-2 gap-4 lg:gap-6">
                <div className="w-full lg:w-1/2">
                    <h6>Test ID</h6>
                    <input
                        type="text"
                        placeholder="ie. D-9000-Z"
                        value={testName}
                        onChange={(e) => dispatch({ type: 'SET_FIELD', payload: { field: 'testName', value: e.target.value } })}
                        className="border border-oi-button-blue h-12 w-full p-2 pr-10 mt-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500  border bg-primary-light dark:bg-primary-dark border-gray-300 dark:border-gray-600 placeholder-gray-400"
                    />
                    {
                        !testName && (
                            <div className="text-left pt-4 text-gray-500">
                                <p className="text-bad-red">*Mandatory field </p>
                            </div>
                        )
                    }
                </div>

                <div className="w-full lg:w-1/2">
                    <h6>Comment</h6>
                    <textarea
                        className="resize-y border w-full p-2 mt-2 pt-3 
             text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 
             bg-primary-light dark:bg-primary-dark 
             border-gray-300 dark:border-gray-600 
             placeholder-gray-400 min-h-12 overflow-hidden"
                        placeholder="Add additional comments here..."
                        rows={1}
                        value={comment}
                        onChange={(e) => {
                            dispatch({ type: 'SET_FIELD', payload: { field: 'comment', value: e.target.value } });
                            e.target.style.height = "auto"; // reset
                            e.target.style.height = `${e.target.scrollHeight}px`; // grow with content
                        }}
                    />
                    {/* <input
                        type="text"
                        placeholder="ie. D-9000-Z"
                        value={commentText}
                        onChange={(e) => handleCommentChange(e.target.value)}
                        className="h-12 w-full p-2 pr-10 mt-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 border bg-primary-light dark:bg-primary-dark border-gray-300 dark:border-gray-600 placeholder-gray-400"
                    /> */}
                </div>

            </div>




        </div >
    );
}